import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRatingStarRibbon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "rating-star-ribbon" }), /* @__PURE__ */ _jsx("path", { d: "M19.5,0H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,3.086,1.679l6.278-4.062a.249.249,0,0,1,.272,0l6.277,4.061A2,2,0,0,0,21.5,22V2A2,2,0,0,0,19.5,0ZM15.461,13.509a.351.351,0,0,1-.494.446l-2.845-1.6a.249.249,0,0,0-.245,0l-2.844,1.6a.351.351,0,0,1-.494-.446l1.173-2.7a.251.251,0,0,0-.063-.286L7.637,8.732a.351.351,0,0,1,.233-.613h2.39a.25.25,0,0,0,.23-.151l1.188-2.756a.351.351,0,0,1,.644,0L13.51,7.968a.25.25,0,0,0,.23.151h2.39a.351.351,0,0,1,.233.613l-2.012,1.792a.251.251,0,0,0-.063.286Z" })]
});
export default SvgRatingStarRibbon;
